(() => {
  if (customElements.get('voicsky-buy-directory')) return;
  const clean = value => (value || '').trim();
  class BuyDirectory extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.branchAnimations = new Map();
      const options = { signal: this.controller.signal };
      this.cards = [...this.querySelectorAll('[data-store]')];
      this.country = this.querySelector('select[data-country]');
      this.search = this.querySelector('[data-search]');
      this.type = '';
      const countries = new Map();
      this.cards.forEach(card => {
        card.dataset.country = clean(card.dataset.country || card.dataset.countryName).toUpperCase();
        if (card.dataset.country) countries.set(card.dataset.country, card.dataset.countryName || card.dataset.country);
      });
      this.country.querySelectorAll('option:not(:first-child)').forEach(option => option.remove());
      [...countries].sort((a,b) => a[1].localeCompare(b[1])).forEach(([code,name]) => this.country.add(new Option(name.toLocaleUpperCase(),code)));
      this.querySelector('.vwtb__filters').hidden = !this.cards.length;
      this.querySelector('.vwtb__types').hidden = !this.cards.length;
      this.querySelector('[data-empty]').hidden = !!this.cards.length;
      this.addEventListener('input', event => {if (event.target === this.search) this.filter();}, options);
      this.addEventListener('change', event => {if (event.target === this.country) this.filter();}, options);
      window.addEventListener('resize', () => this.finishBranchAnimations(), options);
      this.addEventListener('click', event => {
        const summary = event.target.closest('[data-branch-details] > summary');
        if (summary) {event.preventDefault(); this.toggleBranches(summary.parentElement); return;}
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-type')) { this.type = button.dataset.type; this.filter(); }
        if (button.hasAttribute('data-reset')) { this.country.value = ''; this.search.value = ''; this.type = ''; this.filter(); }
      }, options);
      document.addEventListener('voicsky:buy-country', event => {
        if (event.detail.connection !== this.dataset.connection) return;
        this.country.value = event.detail.country;
        this.search.value = ''; this.type = '';
        this.filter();
        if (!event.detail.fromMap) this.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        this.country.value = ''; this.search.value = ''; this.type = ''; this.filter();
      }, options);
      this.filter();
      document.dispatchEvent(new CustomEvent('voicsky:buy-ready'));
    }
    disconnectedCallback() { this.finishBranchAnimations(); this.controller?.abort(); document.dispatchEvent(new CustomEvent('voicsky:buy-ready')); }
    finishBranches(details, opening) {
      const state = this.branchAnimations.get(details);
      this.branchAnimations.delete(details);
      details.open = opening;
      details.style.removeProperty('height');
      details.style.removeProperty('overflow');
      details.removeAttribute('data-collapsing');
      if (state) {state.animation.onfinish = null; state.animation.cancel();}
    }
    finishBranchAnimations() {
      this.branchAnimations?.forEach((state, details) => this.finishBranches(details, state.opening));
    }
    toggleBranches(details) {
      const previous = this.branchAnimations.get(details);
      const opening = previous ? !previous.opening : !details.open;
      const start = details.getBoundingClientRect().height;
      if (previous) {previous.animation.onfinish = null; previous.animation.cancel(); this.branchAnimations.delete(details);}
      details.style.removeProperty('height');
      details.style.removeProperty('overflow');
      details.removeAttribute('data-collapsing');
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {this.finishBranches(details, opening); return;}
      details.open = true;
      const styles = getComputedStyle(details);
      const border = (parseFloat(styles.borderTopWidth) || 0) + (parseFloat(styles.borderBottomWidth) || 0);
      const end = opening ? details.getBoundingClientRect().height : details.querySelector('summary').getBoundingClientRect().height + border;
      const duration = Math.min(420, Math.max(240, 180 + Math.sqrt(Math.abs(end - start)) * 6));
      details.style.height = `${start}px`;
      details.style.overflow = 'hidden';
      details.toggleAttribute('data-collapsing', !opening);
      const animation = details.animate({height: [`${start}px`, `${end}px`]}, {duration, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards'});
      const state = {animation, opening};
      this.branchAnimations.set(details, state);
      animation.onfinish = () => {
        if (this.branchAnimations.get(details) === state) this.finishBranches(details, opening);
      };
    }
    filter() {
      this.finishBranchAnimations();
      let count = 0;
      const query = this.search.value.trim().toLocaleLowerCase();
      this.cards.forEach(card => {
        const d = card.dataset;
        const matchesType = !this.type || d.type === this.type || (this.type === 'distributor' && d.distributor === 'true') || (this.type === 'ecommerce' && d.onlineStore === 'true');
        card.hidden = !!((this.country.value && d.country !== this.country.value) || !matchesType || (query && !card.textContent.toLocaleLowerCase().includes(query)));
        const branches = card.querySelector('[data-branch-details]');
        if (branches && query) branches.open = !card.hidden;
        else if (branches && this.branchSearchActive) branches.open = branches.dataset.defaultOpen === 'true';
        if (!card.hidden) count++;
      });
      this.querySelector('.vwtb__grid').dataset.resultCount = String(count);
      this.branchSearchActive = !!query;
      this.querySelectorAll('button[data-type]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.type === this.type)));
      const status = this.querySelector('[data-count]');
      status.hidden = !this.cards.length;
      status.textContent = `${count} ${count === 1 ? status.dataset.single : status.dataset.label}`;
      this.querySelector('[data-no-results]').hidden = count > 0 || !this.cards.length;
      document.dispatchEvent(new CustomEvent('voicsky:buy-filter',{detail:{connection:this.dataset.connection,country:this.country.value}}));
    }
  }
  customElements.define('voicsky-buy-directory', BuyDirectory);
})();
